<template>
  <el-pagination style="text-align:center;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
    :current-page="page" :page-sizes="size_list" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
    :total="total">
  </el-pagination>
</template>

<script>
  export default {
    created() {
      this.getTotalsize();
    },
    props: ["totalCountOrURL", "params"],
    watch: {
      totalCountOrURL() {
        this.getTotalsize();
      },
      params() {
        this.getTotalsize();
      }
    },
    methods: {
      getTotalsize() {
        if (typeof (this.totalCountOrURL) == "number") {
          // 为number表示前台分页 值即为总数  不需要从后台查询
          this.total = this.totalCountOrURL;
        } else {
          // 参数若没有初始化 则不向后台发送请求 (应避免参数本身就为null的情况)
          for (let p in this.params) {
            if (!this.params[p]) {
              return;
            }
          }
          this.$getJSON(this.totalCountOrURL, this.params).then(res => {
            this.total = res.data[0].count;
            // 总数变化后，页码初始化为1
            this.page = 1;
          });
        }

      },
      handleSizeChange(a) {
        this.size = a;
        if (this.page > Math.ceil(this.total / this.size)) {
          this.page = Math.ceil(this.total / this.size);
        }
        this.$emit("change", {
          page: this.page,
          size: this.size
        });
      },
      handleCurrentChange(a) {
        this.page = a;
        this.$emit("change", {
          page: this.page,
          size: this.size
        });
      }
    },
    data() {
      return {
        size_list: [10, 20, 30, 40],
        total: 400,
        page: 1,
        size: 10
      };
    }
  };

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/PageNations/Pagination.vue